module.exports = "/_next/static/images/Powered-konfhub-logo-white-2de1deaa9c7d3c77e213e557167c28fd.svg";